import { FullMetadata } from 'firebase/storage'

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB']
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  const size = bytes / Math.pow(1024, i)
  return `${size % 1 === 0 ? size : size.toFixed(2)} ${units[i]}`
}

export async function downloadFile(url: string, filename: string): Promise<void> {
  const response = await fetch(url)
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = filename
  a.click()
  URL.revokeObjectURL(blobUrl)
}

export async function downloadFilesAsZip(
  files: { meta: FullMetadata; url: string }[],
  zipFilename: string
): Promise<void> {
  const { default: JSZip } = await import('jszip')
  const zip = new JSZip()
  const usedNames = new Set<string>()
  await Promise.all(
    files.map(async (file, index) => {
      const response = await fetch(file.url)
      const blob = await response.blob()
      let filename = file.meta.name ?? `file-${index + 1}`
      if (usedNames.has(filename)) {
        const ext = filename.includes('.') ? filename.slice(filename.lastIndexOf('.')) : ''
        const base = filename.includes('.')
          ? filename.slice(0, filename.lastIndexOf('.'))
          : filename
        let n = 1
        while (usedNames.has(`${base}-${n}${ext}`)) n++
        filename = `${base}-${n}${ext}`
      }
      usedNames.add(filename)
      zip.file(filename, blob)
    })
  )
  const content = await zip.generateAsync({ type: 'blob' })
  const blobUrl = URL.createObjectURL(content)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = zipFilename
  a.click()
  URL.revokeObjectURL(blobUrl)
}

export const fileExtensionColors: Record<string, { bg: string; color: string }> = {
  jpg: { bg: '#E3F2FD', color: '#1565C0' },
  jpeg: { bg: '#E3F2FD', color: '#1565C0' },
  png: { bg: '#E8F5E9', color: '#2E7D32' },
  gif: { bg: '#FFF3E0', color: '#E65100' },
  pdf: { bg: '#FFEBEE', color: '#C62828' },
  svg: { bg: '#F3E5F5', color: '#6A1B9A' },
  webp: { bg: '#E0F7FA', color: '#00838F' },
}
